import React from 'react'
import PropTypes from 'prop-types'
import { format } from 'date-fns'
import { Grid, Row, Col, Text, Margin, Panel, Link } from 'shared/components'
import { InWinImage } from 'routes/shared/components'

import { getSport } from './helpers'
import * as styles from './styles'

const AthleteDetailsPanelComponent = ({ athlete }) => (
  <Panel>
    <main>
      <Grid>
        <Row>
          <Col xs={8}>
            <Margin bottom={2} css={styles.header}>
              <Text as="h1" size={20} bold>
                {athlete?.fullName}
              </Text>
            </Margin>
            <Margin tb={1}>
              <Text>Nationality: </Text>
              <Text bold>{athlete?.nationality}</Text>
            </Margin>
            <Margin tb={1}>
              <Text>Birthdate: </Text>
              <Text bold>
                {athlete?.dateOfBirth &&
                  format(athlete?.dateOfBirth, 'MMMM dd, y')}
              </Text>
            </Margin>
            <Margin tb={1}>
              <Text>Sport: </Text>
              <Text bold>{getSport(athlete?.sport)}</Text>
            </Margin>
            <Margin tb={1}>
              <Link as="a" href={athlete?.personalWebsite}>
                {athlete?.personalWebsite}
              </Link>
            </Margin>
          </Col>
          <Col xs={4}>
            <div css={styles.logoWrapper}>
              {athlete?.logo && (
                <InWinImage
                  source={athlete?.logo}
                  fallbackSource="/img/avatar-placeholder.png"
                  alt={athlete?.logo}
                  css={styles.logo}
                />
              )}
            </div>
          </Col>
        </Row>
      </Grid>
    </main>
  </Panel>
)

AthleteDetailsPanelComponent.propTypes = {
  athlete: PropTypes.shape(),
}

export default AthleteDetailsPanelComponent
